import { action, observable, makeObservable, runInAction } from 'mobx';
import { get } from 'stores/_services/dataService';

export interface IAlertSource {
    id: string | null;
    name: string;
    source: string;
}

export default class AlertSourceStore {
    alertSource: IAlertSource = {
        id: '',
        name: '',
        source: ''
    };

    constructor() {
        makeObservable(this, {
            alertSource: observable,
            _updateData: action
        });
    }

    async getAlertSource(): Promise<void> {
        const { data } = await get('alertSources');
        this._updateData(data);
    }

    _updateData(data: IAlertSource): void {
        //every step that updates observables in an asynchronous process should be marked as action(one way to use is runInAction), Only synchronous changes to observable data works in actions
        runInAction(() => {
            this.alertSource = {
                ...data
            };
        });
    }
}
